import { render } from "./SimpleNotification.vue?vue&type=template&id=13e1ba01&scoped=true"
import script from "./SimpleNotification.vue?vue&type=script&lang=js"
export * from "./SimpleNotification.vue?vue&type=script&lang=js"

import "./SimpleNotification.vue?vue&type=style&index=0&id=13e1ba01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13e1ba01"]])

export default __exports__